const INITIAL_STATE = {
  data: {},
  errors: {},
}
  
const getCardList = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_CARD_LIST':
    return { ...state, ...INITIAL_STATE, data: action.data }
  case 'GET_CARD_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
  
export default getCardList;